import { Injectable } from '@angular/core';
import { HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private excludedUrlsRegex: RegExp[];

  private excludedUrls = ['.svg'];

  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService) {
    this.excludedUrlsRegex = this.excludedUrls.map((urlPattern) => new RegExp(urlPattern, 'i')) || [];
  }

  removeRequest(req: HttpRequest<any>): void {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const passThrough = !!this.excludedUrlsRegex.find((regex) => regex.test(req.url));

    if (passThrough) {
      return next.handle(req);
    }

    const splitReq = req.url.split('/');

    this.requests.push(req);

    if (splitReq[splitReq.length - 1] !== 'token') {
      this.loaderService.isLoading.next(true);
    }

    return new Observable((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        (err) => {
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        },
      );
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
